<script setup lang="ts">
defineEmits<{
  submit: []
}>()

const formTypes = defineModel<SearchFormTypes>({ required: true })

const { vehicleOptions } = useOrderedVehicleOptions()

const { getTranslatedVehicleDescriptionForTypeInt } = useGetTranslatedVehicleDescriptionForTypeInt()
</script>

<template>
  <form
    id="search-form-types"
    class="w-full md:w-max md:max-h-[calc(100vh-15rem)] overflow-y-auto p-4 flex flex-col items-center"
    @submit.prevent="$emit('submit')"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <YscInputCheckboxCard
        v-for="option in vehicleOptions"
        :id="`dropdown-type-${option.value}`"
        :key="`dropdown-checkbox-search-${option.value}`"
        v-model:checked="formTypes.types"
        :value="option.value"
        name="dropdown-type"
        class="p-3 w-full md:w-48 text-start flex flex-col justify-start items-start"
      >
        <YscIconsTypeVehicle
          class="w-[4.5rem]"
          :type="option.value"
        />
        <label
          class="mt-2 font-semibold text-sm leading-tight"
          for="`dropdown-type-${option.value}`"
        >{{ option.text }}</label>
        <p class="text-xs text-gray-500 mt-0.5">
          {{ getTranslatedVehicleDescriptionForTypeInt(option.value) }}
        </p>
      </YscInputCheckboxCard>
    </div>
  </form>
</template>
